import React, { useState, useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Logout from "./Logout";
import Sidebar from "./Sidebar";
import "../../assets/css/return.css";
import AuthHeader from "../../components/AuthHeader/AuthHeader";

const Return_Requests = () => {
	function return_order() {
		window.location.href = "/Return_detail";
	}
	return (
		<>
			<AuthHeader />
			{/* My adresses starts here */}
			<section className="my-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Sidebar />
						</div>
						<div className="col-lg-9">
							<Logout />
							{/* return payment starts here */}
							<div className="return-request-wrapper">
								<div className="return-heading-wrapper">
									<h3>Return Requests</h3>
								</div>
								<div className="return-table-wrapper">
									<div className="table-responsive">
										<table className="table">
											<thead>
												<tr>
													<th className="Order-h">Order Id</th>
													<th className="Date-h">Order Date</th>
													<th className="Return-h">Return Request</th>
													<th className="Payment-h">Payment Status</th>
													<th className="Total-h">Total</th>
													<th className="detail-h"></th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td className="order-id">
														<span>#1084598423154</span>
													</td>
													<td className="date-id">
														<span>04-12-21</span>
													</td>
													<td className="reject-id">
														<span className="reject">Rejected</span>
													</td>
													<td className="order-id">
														<span className="paid">
															Paid <i className="fa fa-check-circle"></i>
														</span>
													</td>
													<td className="total">
														<span>$590.00</span>
													</td>
													<td className="btns">
														<button onClick={return_order} className="btn">
															view Details
														</button>
													</td>
												</tr>
												<tr>
													<td className="order-id">
														<span>#1084598423154</span>
													</td>
													<td className="date-id">
														<span>04-12-21</span>
													</td>
													<td className="reject-id">
														<span className="reject">Rejected</span>
													</td>
													<td className="order-id">
														<span className="paid">
															Paid <i className="fa fa-check-circle"></i>
														</span>
													</td>
													<td className="total">
														<span>$590.00</span>
													</td>
													<td className="btns">
														<button className="btn">view Details</button>
													</td>
												</tr>
												<tr>
													<td className="order-id">
														<span>#1084598423154</span>
													</td>
													<td className="date-id">
														<span>04-12-21</span>
													</td>
													<td className="reject-id">
														<span className="reject">Rejected</span>
													</td>
													<td className="order-id">
														<span className="paid">
															Paid <i className="fa fa-check-circle"></i>
														</span>
													</td>
													<td className="total">
														<span>$590.00</span>
													</td>
													<td className="btns">
														<button className="btn">view Details</button>
													</td>
												</tr>
												<tr>
													<td className="order-id">
														<span>#1084598423154</span>
													</td>
													<td className="date-id">
														<span>04-12-21</span>
													</td>
													<td className="reject-id">
														<span className="Accepted">Accepted</span>
													</td>
													<td className="order-id">
														<span className="paid">
															Paid <i className="fa fa-check-circle"></i>
														</span>
													</td>
													<td className="total">
														<span>$590.00</span>
													</td>
													<td className="btns">
														<button className="btn">view Details</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							{/* return payment ends here */}
						</div>
					</div>
				</div>
			</section>
			{/* My adresses ends here */}
			<Footer />
		</>
	);
};

export default Return_Requests;
